// src/pages/CourseDetailPage.jsx
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import styles from './CourseDetailPage.module.css';
import allCoursesData from '../data/courses'; // Your hardcoded data
import CourseTrainerCard from '../components/courses/CourseTrainerCard'; // New component
import CtaBanner from '../components/includes/CtaBanner'; // Re-use common CTA
import coursesHeroBg from '../assets/imgs/Bspark-Corp-Train-courses-Banner-1-01.jpg'; // Corrected import to the right image
const CourseDetailPage = ({setIsPopupVisible}) => {
 const { courseId } = useParams(); // Get the course ID from the URL (e.g., 'full-stack-web-development')
 const navigate = useNavigate(); // For navigation if course not found
 const [course, setCourse] = useState(null);
 const [activeTab, setActiveTab] = useState('overview'); // State for controlling active tab

 useEffect(() => {
 // In a real application, you would fetch this from an API:
 // fetch(`/api/courses/${courseId}`)
 //   .then(res => res.json())
//   .then(data => setCourse(data))
 //   .catch(err => {
 //     console.error("Error fetching course:", err);
 //     navigate('/courses', { replace: true }); // Redirect if not found
 //   });
 // For now, find from hardcoded data
 const foundCourse = allCoursesData.find(c => c.id === courseId);
 if (foundCourse) {
 setCourse(foundCourse);
 // Add this line to set the dynamic page title
document.title = `Best ${foundCourse.title} Training institute in Chennai || Bspark Software Technologies  `;
 } else {
 // If course not found, redirect back to the courses list or a 404 page
 navigate('/courses', { replace: true });
 // Alternatively, set an error message: setError('Course not found.');
}
 }, [courseId, navigate]); // Re-run effect if courseId or navigate changes

if (!course) {
 // You could replace this with a loading spinner component
 return (
 <div className={styles.loadingContainer}>
 <p>Loading course details...</p>
 </div>
 );
}
  return (
   <div className={styles.courseDetailPage}>
      {/* Course Hero/Banner Section */}
      <section className={styles.courseHero} style={{ backgroundImage: `url(${coursesHeroBg})` }}>
        <div className={styles.heroContentContainer}> {/* New wrapper for content */}
          <div className={styles.heroContent}>
            {/* The icon is part of the background image, so it's not needed here */}
            {/* {course.image && <img src={course.image} alt={course.title} className={styles.heroCourseIcon} />} */}
            <h1 className={styles.courseTitle}>{course.title}</h1>
            <p className={styles.courseShortDescription}>{course.shortDescription}</p>
            <div className={styles.courseMeta}>
              <span>Duration: {course.duration}</span>
              <span>Delivery: {course.delivery}</span>
            </div>
            <button className="cta-button" onClick={() => setIsPopupVisible(true)}>Enroll Now</button>
          </div>
        </div>
      </section>


      {/* Tabs for detailed sections */}
      <section className={styles.tabsSection}>
        <div className={styles.tabNav}>
          <button
            className={`${styles.tabButton} ${activeTab === 'overview' ? styles.active : ''}`}
            onClick={() => setActiveTab('overview')}
          >
            Overview
          </button>
          <button
            className={`${styles.tabButton} ${activeTab === 'syllabus' ? styles.active : ''}`}
            onClick={() => setActiveTab('syllabus')}
          >
            Syllabus
          </button>
          <button
            className={`${styles.tabButton} ${activeTab === 'scope' ? styles.active : ''}`}
            onClick={() => setActiveTab('scope')}
          >
            Career Scope
          </button>
          <button
            className={`${styles.tabButton} ${activeTab === 'trainers' ? styles.active : ''}`}
            onClick={() => setActiveTab('trainers')}
          >
            Our Trainers
          </button>
        </div>

        <div className={styles.tabContent}>
          {activeTab === 'overview' && (
            <div className={styles.contentBlock}>
              <h2 className={styles.contentTitle}>About This Course</h2>
              <p className={styles.introText}>{course.intro}</p>
              <h4>Course Highlights:</h4>
              <ul className={styles.highlightsList}>
                {course.features.map((feature, index) => (
                  <li key={index}>{feature}</li>
                ))}
              </ul>
            </div>
          )}

          {activeTab === 'syllabus' && (
            <div className={styles.contentBlock}>
              <h2 className={styles.contentTitle}>Detailed Syllabus</h2>
              {course.syllabus.map((section, index) => (
                <div key={index} className={styles.syllabusSection}>
                  <h3>{section.section}</h3>
                  <ul>
                    {section.topics.map((topic, i) => (
                      <li key={i}>{topic}</li>
                    ))}
                  </ul>
                </div>
              ))}
              {/* Optional: Add a download syllabus button */}
              {/* <button className="cta-button">Download Full Syllabus</button> */}
            </div>
          )}

          {activeTab === 'scope' && (
            <div className={styles.contentBlock}>
              <h2 className={styles.contentTitle}>Career Scope & Opportunities</h2>
              <p>Upon successful completion of this course, you will be prepared for roles such as:</p>
              <ul className={styles.scopeList}>
                {course.scope.map((role, index) => (
                  <li key={index}>{role}</li>
                ))}
              </ul>
              <p className={styles.scopeCallout}>
                Our placement assistance program will help you connect with top companies and land your dream job!
              </p>
            </div>
          )}

          {activeTab === 'trainers' && (
            <div className={styles.contentBlock}>
              <h2 className={styles.contentTitle}>Meet Your Expert Trainers</h2>
              <div className={styles.trainersGrid}>
                {course.trainers.map(trainer => (
                  <CourseTrainerCard key={trainer.name} trainer={trainer} />
                ))}
              </div>
            </div>
          )}
        </div>
      </section>

      {/* Re-use CTA banner at the bottom */}
      <CtaBanner
        title="Ready to Launch Your Career?"
        subtitle="Enroll in our upcoming batch or speak to an advisor to learn more about admissions!"
        buttonText="Inquire Now"
        buttonLink="/contact"
      />
    </div>
  );
};

export default CourseDetailPage;